import React from 'react';
import { Link } from '@metarouter-private/mr-mui';
import { useTransformationLibTableContext } from 'app/clusters/TransformationLibTab/TransformationLibTable/TransformationLibTableContext';
import NoDataText from 'app/components/data-table/NoDataText';

function TransformationLibNoData() {
  const { cluster, hasFiltersInUse, transformLibModules } = useTransformationLibTableContext();

  // initial message when there are multiple clusters to choose from
  if (!cluster) {
    return <NoDataText>Please select a cluster.</NoDataText>;
  }

  // message when filtering and no results
  if (hasFiltersInUse && transformLibModules.length === 0) {
    return <NoDataText>No results found. Please adjust the filters and try again.</NoDataText>;
  }

  // default message for any "no results"
  return (
    <NoDataText>
      LUA Modules can be added using the CLI (
      <Link
        href="https://docs.metarouter.io/docs/transformation-library#how-transformation-library-lua-modules-works"
        target="_blank"
        rel="noopener"
      >
        docs
      </Link>
      ). Reach out to your Account Manager to unlock this feature.
    </NoDataText>
  );
}

export default TransformationLibNoData;
